import posthog from 'posthog-js';

let posthogInitialized = false;

export function initPostHog() {
  if (typeof window === 'undefined') return;
  if (!ENV.POSTHOG_PROJECT_TOKEN) return;
  if (posthogInitialized) return;

  const isDev = ENV.MODE === 'development';

  const disablePosthogIngestProxy = ENV.POSTHOG_DISABLE_INGEST_PROXY === 'true';

  posthog.init(ENV.POSTHOG_PROJECT_TOKEN, {
    ...(!disablePosthogIngestProxy ? { api_host: '/ingest' } : {}),
    ui_host: 'https://us.posthog.com',
    defaults: '2026-01-30',
    debug: isDev,
    person_profiles: 'identified_only',

    capture_pageview: false,
    capture_pageleave: true,
    capture_exceptions: true,
    autocapture: true,

    disable_session_recording: isDev,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '*',
    },
    enable_recording_console_log: !isDev,
  });

  posthogInitialized = true;
}
